import { render } from "./AccountBaseView.vue?vue&type=template&id=dc148eb8"
import script from "./AccountBaseView.vue?vue&type=script&lang=js"
export * from "./AccountBaseView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__